import React from "react";
import styled from "styled-components";
const CustomRadioButton = ({ label, value, name, register, checked }) => {
  return (
    <RadioWrapper  checked={checked}>
      <input
        className="radio-input"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        {...register(name, { required: true })}
      />
      <span className="radio-text mx-2">{label}</span>
    </RadioWrapper>
  );
};
export default CustomRadioButton;
export const RadioWrapper = styled.label`
  display: flex;
  align-items: end;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);
  border: 1px solid
    ${(props) => (props.checked ? "var(--secondaryColor)" : "var(--border)")};
  .radio-input {
    appearance: none;
    min-width: 25px;
	  max-width: 25px;
    height: 25px;
    border: 2px solid var(--border);
      background-color: var(--bg);
    border-radius: 50%;
    position: relative;
    &:checked {
        border: 7px solid var(--secondaryColor);
        background-color: var(--secondaryColor);
    }
    &:checked::after {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: var(--white);
    }
  }
  .radio-text {
    font-family: ${(props) => (props.checked ? "var(--semiBold)" : "var(--medium)")};
    color: ${(props) => (props.checked ? "var(--secondaryColor)" : "var(--darkGrey)")};
    body.rtl &{
      font-family: ${(props) => (props.checked ? "var(--arSemiBold)" : "var(--arMedium)")};
    }
  }
`;